// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "boundingBoxRendererFragmentDeclaration";
const shader = `uniform vec4 color;`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export const boundingBoxRendererFragmentDeclaration = { name, shader };
